import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useAuth } from '../lib/auth';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}!`);
      navigate(user.role === 'admin' || user.role === 'super_admin' ? '/admin' : '/');
    } catch { toast.error('Invalid email or password'); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen pt-20 flex items-center justify-center px-4 bg-stone-50" data-testid="login-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="font-heading text-3xl font-bold text-stone-800">Welcome Back</h1>
          <p className="text-sm text-stone-500 mt-2">Sign in to access your dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white border border-stone-200 rounded-2xl p-8 shadow-sm space-y-5">
          <div><label className="text-[10px] uppercase tracking-widest text-stone-400 mb-1.5 block font-medium">Email</label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="bg-stone-50 border-stone-200 rounded-xl h-12" data-testid="login-email" /></div>
          <div><label className="text-[10px] uppercase tracking-widest text-stone-400 mb-1.5 block font-medium">Password</label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="bg-stone-50 border-stone-200 rounded-xl h-12" data-testid="login-password" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-gold hover:bg-[#9A7B1F] text-white h-12 text-xs uppercase tracking-[0.2em] font-semibold rounded-full" data-testid="login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign In'}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
